import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAATklEQVR42k2NQQoAIQwD/f+/3EdovYiUfqG026wuiA4kuQwkYRIReN3/XbnwtJqZ8eSMWitaa+i9w8yOICIYY4CIUEoBTVFVj7DZF9eNf7wYe0O8J0TkAAAAAElFTkSuQmCC"};
